import AdminShellPage from '@/admin/pages/AdminShellPage.vue'
import AdminUsersPage from '@/admin/pages/AdminUsersPage.vue'
import AdminAiProfilesPage from '@/admin/pages/AdminAiProfilesPage.vue'
import AdminPropertiesPage from '@/admin/pages/AdminPropertiesPage.vue'
import AdminStreamSettingsPage from '@/admin/pages/AdminStreamSettingsPage.vue'
import AdminAiPricingPage from '@/admin/pages/AdminAiPricingPage.vue'
import AdminStreamsPage from '@/admin/pages/AdminStreamsPage.vue'
import AdminStatisticsPage from '@/admin/pages/AdminStatisticsPage.vue'
import AdminRssPage from '@/admin/pages/AdminRssPage.vue'
import AdminInvitesPage from '@/admin/pages/AdminInvitesPage.vue'

export const adminRoutes = [
  {
    path: '/admin',
    component: AdminShellPage,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: '',
        redirect: { name: 'AdminStatistics' },
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: AdminUsersPage,
        meta: { title: 'Админ: пользователи' },
      },
      {
        path: 'ai-profiles',
        name: 'AdminAiProfiles',
        component: AdminAiProfilesPage,
        meta: { title: 'Админ: AI-профили' },
      },
      {
        path: 'properties',
        name: 'AdminProperties',
        component: AdminPropertiesPage,
        meta: { title: 'Админ: свойства' },
      },
      {
        path: 'stream-settings',
        name: 'AdminStreamSettings',
        component: AdminStreamSettingsPage,
        meta: { title: 'Админ: настройки потоков' },
      },
      {
        path: 'ai-pricing',
        name: 'AdminAiPricing',
        component: AdminAiPricingPage,
        meta: { title: 'Админ: тарифы AI' },
      },
      {
        path: 'streams',
        name: 'AdminStreams',
        component: AdminStreamsPage,
        meta: { title: 'Админ: потоки' },
      },
      {
        path: 'statistics',
        name: 'AdminStatistics',
        component: AdminStatisticsPage,
        meta: { title: 'Админ: статистика' },
      },
      {
        path: 'rss',
        name: 'AdminRss',
        component: AdminRssPage,
        meta: { title: 'Админ: RSS' },
      },
      {
        path: 'invites',
        name: 'AdminInvites',
        component: AdminInvitesPage,
        meta: { title: 'Админ: приглашения' },
      },
    ],
  },
]
